import { render } from "./AddressEdit.vue?vue&type=template&id=cd95dbec&scoped=true"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&id=cd95dbec&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_ba160c7cc2f29ece52adbe34bb7fc3d0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd95dbec"]])

export default __exports__